<template>
    <div id="menu-view">
        
    </div>
</template>

<script>

export default {
    name:'menu'
}

</script>

<style lang="scss">

#menu-view{
    position: fixed;
    width:100vw;
    height:100vh;
    z-index: 1001;
    background: rgba(0,0,0,0.2);
    transition: 0.5s;
}

</style>